export const BASE_URL = 'https://thummimng.com/'